import { API_BASE_URL } from 'api/constants';
import { buildURL } from 'utils/helpers';

export const endpoints = {
  //SHARED
  getDashboard: (params) => buildURL(API_BASE_URL, '/api/admin/me/dashboard', params),
  getUserProfile: `${API_BASE_URL}/api/admin/me/profile`,
  getClients: (params) => buildURL(API_BASE_URL, '/api/admin/clients/list', params),
  getAllInvoices: (params) => buildURL(API_BASE_URL, '/api/admin/finances/invoices', params),
  adminLogin: `${API_BASE_URL}/api/admin/auth/login`,
  managerLogin: `${API_BASE_URL}/api/manager/auth/login`,
  getFinancesSummary: (params) => buildURL(API_BASE_URL, '/api/admin/finances/summary', params),
  getFinancesClients: (params) => buildURL(API_BASE_URL, '/api/admin/finances/clients', params),
  getPartner: (partner_id) => `${API_BASE_URL}/api/partner/${partner_id}`,
  getUser: (user_id) => `${API_BASE_URL}/api/admin/${user_id}/details`,
  terminateUser: (user_id) => `${API_BASE_URL}/api/admin/${user_id}/terminate`,
  getUserTasks: (user_id, week_id) => `${API_BASE_URL}/api/admin/${user_id}/forms?week=${week_id}`,
  updateUser: (user_id) => `${API_BASE_URL}/api/admin/${user_id}/update`,
  getInvoice: (invoice_id) => `${API_BASE_URL}/api/admin/finances/invoice/${invoice_id}`,
  getTerminationReasons: `${API_BASE_URL}/api/common/termination_reasons`,
  forgotPassword: `${API_BASE_URL}/api/admin/forgotpassword`,
  verifyCode: `${API_BASE_URL}/api/admin/verify-code`,
  resetPassword: `${API_BASE_URL}/api/admin/resetpassword`,
  verifyInvitation: `${API_BASE_URL}/api/admin/verify-invitation`,
  resendInvitation: (admin_id) =>
    `${API_BASE_URL}/api/admin/administrator/${admin_id}/resend-invitation`,
  resendManagerInvitation: (manager_id) =>
    `${API_BASE_URL}/api/admin/slh-manager/${manager_id}/resend-invitation`,
  getSLhObligations: (params) => buildURL(API_BASE_URL, '/api/admin/finances/slh-summary', params),

  // ADMIN
  registerClient: `${API_BASE_URL}/api/client/register`,
  getForms: `${API_BASE_URL}/api/common/forms`,
  uploadAvatar: (userID) => `${API_BASE_URL}/api/admin/${userID}/upload-image`,
  uploadDocument: (userID) => `${API_BASE_URL}/api/admin/${userID}/upload-document`,
  getPartners: (params) => buildURL(API_BASE_URL, '/api/partner/list', params),
  registerPartner: `${API_BASE_URL}/api/partner`,
  updatePartner: (partner_id) => `${API_BASE_URL}/api/partner/${partner_id}`,
  getFinancesPartners: `${API_BASE_URL}/api/admin/finances/partners`,
  getWeeklyClientInvoices: (partner_id, period = 'weekly', page = 1) =>
    `${API_BASE_URL}/api/partner/${partner_id}/invoice-list?period=${period}&page=${page}`,
  getPF25Admins: (params) => buildURL(API_BASE_URL, '/api/admin/administrators', params),
  createPF25Admin: `${API_BASE_URL}/api/admin/administrator`,
  editPF25Admin: (admin_id) => `${API_BASE_URL}/api/admin/administrator/${admin_id}`,
  activatePF25Admin: (admin_id) => `${API_BASE_URL}/api/admin/administrator/${admin_id}/activate`,
  deactivatePF25Admin: (admin_id) =>
    `${API_BASE_URL}/api/admin/administrator/${admin_id}/deactivate`,
  createSLHManager: `${API_BASE_URL}/api/admin/slh-manager`,
  editSLHManager: (managerId) => `${API_BASE_URL}/api/admin/slh-manager/${managerId}`,
  activateSLHManager: (managerId) => `${API_BASE_URL}/api/admin/slh-manager/${managerId}/activate`,
  assignChildPartner: `${API_BASE_URL}/api/partner/assign-child-partner`,
  getAllPartners: (partner_type) =>
    partner_type
      ? `${API_BASE_URL}/api/partner/all?type=${partner_type}`
      : `${API_BASE_URL}/api/partner/all`,
  getAllSLHManagers: (params) => buildURL(API_BASE_URL, '/api/admin/slh-managers', params),
  toggleUserNotificationsByAdmin: (userId) =>
    `${API_BASE_URL}/api/admin/administrator/${userId}/notifications`,

  //MANAGER
  submitInvoice: (invoice_id) => `${API_BASE_URL}/api/admin/finances/invoice/${invoice_id}/submit`,
  addAdditionalPayments: (invoice_id) =>
    `${API_BASE_URL}/api/admin/finances/invoice/${invoice_id}/additional-payments`,
  removeAdditionalPayments: (invoice_id, payment_id) =>
    `${API_BASE_URL}/api/admin/finances/invoice/${invoice_id}/additional-payment/${payment_id}`,
  updateBedsOccupancy: (partner_id) => `${API_BASE_URL}/api/partner/${partner_id}/beds`,
  exportInvoice: (invoice_id) => `${API_BASE_URL}/api/admin/finances/invoice/${invoice_id}/export`,
  getSLHManagers: (params) => buildURL(API_BASE_URL, '/api/admin/slh-managers', params),
  deactivateSLHManager: (managerId) =>
    `${API_BASE_URL}/api/admin/slh-manager/${managerId}/deactivate`,
  releaseSystemClientBed: (partner_id, user_id) =>
    `${API_BASE_URL}/api/partner/${partner_id}/bed/${user_id}/release`,
  toggleUserNotificationsByManager: (userId) =>
    `${API_BASE_URL}/api/admin/slh-manager/${userId}/notifications`,

  // CLIENT
  clientLogin: `${API_BASE_URL}/api/auth/login`,
  clientProfile: `${API_BASE_URL}/api/client/me/profile`,
  clientDashboard: `${API_BASE_URL}/api/client/me/dashboard`,
  clientSubmitFeedback: `${API_BASE_URL}/api/client/feedback`,
  getClientFormsByWeek: (week) => `${API_BASE_URL}/api/client/me/forms?week=${week}`,
  clientForgotPassword: `${API_BASE_URL}/api/client/forgotpassword`,
  clientVerifyCode: `${API_BASE_URL}/api/client/verify-code`,
  clientResetPassword: `${API_BASE_URL}/api/client/resetpassword`,
};
